import React, { useEffect, useState } from "react";

import step1 from "../../images/step1.svg";
import step2 from "../../images/step2.svg";
import step3 from "../../images/Step3.svg";
import step4 from "../../images/Step4.svg";

import work1 from "../../images/work1.svg";
import work2 from "../../images/work2.svg";
import work3 from "../../images/work3.svg";
import work4 from "../../images/work4.svg";

import iconcheck from "../../images/icon-check.png";

import { getCuisineAction } from '../../store/actions/CuisineActions';

import DeliveryBoy from "../../images/deliveryBoy.jpg"

import { Link } from "react-router-dom";
import '../../scss/pages/_register.scss';
import foodhublogo from "../../images/foodhublogo.png"
import footerlogo from "../../images/footerlogo.png"
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  loadingToggleAction,
  signupAction,
} from '../../store/actions/AuthActions';

import Select from "react-select";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

//import Select from '@mui/material/Select';


import { createRestaurantAction } from '../../store/actions/RestaurantActions';
import { getBusinessCategoriesAction } from "../../store/actions/RegistrationActions";


function Register(props) {


  const allBusinessCategories = useSelector((state) => state.allBusinessCategories?.businesscategories);
  const allCuisines = useSelector((state) => state.allCuisines?.cuisines);


  const averageCostOption = [
    { value: "$", label: "$ = Less than 150 BDT" },
    { value: "$$", label: "$$ = Less than 300 BDT" },
    { value: "$$$", label: "$$$ = Less than 1000 BDT" }
  ];

  const typeOption = [
    { value: "restaurant", label: "Restaurant" },
    { value: "store", label: "Shop", },
  ];

  const categoryOptions = allBusinessCategories.payload?.map(category => {
    const option = {};
    option['value'] = category.id;
    option['label'] = category.name;
    //option['name'] = 'business_category_id';
    return option;
  });

  const cuisineOptions = allCuisines.payload?.map(cuisine => {
    const option = {};
    option['value'] = cuisine.id;
    option['label'] = cuisine.name;
    // option['name'] = 'cuisine_id';
    return option;
  });


  const [restaurant, setRestaurant] = useState({
    name: "",
    image: "",
    email: "",
    address: "",
    phone: "",
    average_cost: "average_cost",
    outlet_type: "outlet_type",
    business_category_id: "business_category_id",
    cuisine_id: "cuisine_id",
    firstName: "",
    lastName: "",
    price:""

  });

  const [category, setCategory] = useState(false);

  const [cuisine, setCuisine] = useState(false);
  const [outlet, setOutlet] = useState(false);



  const dispatch = useDispatch();


  const [errors, setErrors] = useState(
    {
      name: false,
      outlettype: false,
      category: false,
      cuisine_error: false,
      average: false,
      firstname: false,
      lastname: false,
      phone: false,
      email: false,
      fileitem: false,
      price: false,
    }
  );




  function onFormFieldChange(e) {

    setRestaurant({
      ...restaurant,
      [e.target.name]: e.target.value
    });
  }



  const onFormSelectChange = (event) => {

    if (event.target.name === 'outlet_type') {
      setCategory(true);
      fetchBusinessCategories(event.target.value);

      if (event.target.value === 'restaurant') {
        setOutlet(true);
      } else {
        setOutlet(false);
      }

    } else if ((event.target.name === 'business_category_id')) {
      setCuisine(true);
      fetchCuisine();
    }


    setRestaurant({
      ...restaurant,
      [event.target.name]: event.target.value
    });
  };





  let handleInputBlur = (e) => {

    if (e.target.name === 'name') {
      if (e.target.value === '') {
        setErrors({
          ...errors,
          name: true
        });
      } else {
        setErrors({
          ...errors,
          name: false
        });
      }

    } else if (e.target.name === 'firstName') {
      if (e.target.value === '') {
        setErrors({
          ...errors,
          firstname: true
        });
      } else {
        setErrors({
          ...errors,
          firstname: false
        });
      }
    } else if (e.target.name === 'lastName') {
      if (e.target.value === '') {
        setErrors({
          ...errors,
          lastname: true
        });
      } else {
        setErrors({
          ...errors,
          lastname: false
        });

      }
    } else if (e.target.name === 'phone') {
      if (e.target.value === '') {
        setErrors({
          ...errors,
          phone: true
        });
      } else {
        setErrors({
          ...errors,
          phone: false
        });
      }
    } else if (e.target.name === 'email') {
      if (e.target.value === '') {
        setErrors({
          ...errors,
          email: true
        });
      } else {
        setErrors({
          ...errors,
          email: false
        });
      }
    } else if (e.target.name === 'file') {
     // console.log(e.target.value.length);
      if (e.target.value.length == 0) {
        setErrors({
          ...errors,
          fileitem: true
        });
      } else {
        setErrors({
          ...errors,
          fileitem: false
        });
      }

    } else if (e.target.name === 'is_price_not_fixed') {

      if (e.target.checked === false) {
        setErrors({
          ...errors,
          price: true
        });
      } else {
        setErrors({
          ...errors,
          price: false
        });
      }
    }

  }




  const handleSelectBlur = (event) => {

    if (event.target.name === 'outlet_type') {

      if (event.target.value == 'outlet_type') {
        setErrors({
          ...errors,
          outlettype: true
        });
      } else {
        setErrors({
          ...errors,
          outlettype: false
        });
      }

    } else if (event.target.name == 'business_category_id') {
      console.log(event.target.value)
      if (event.target.value == 'business_category_id') {
        setErrors({
          ...errors,
          category: true
        });
      } else {
        setErrors({
          ...errors,
          category: false
        });
      }
    } else if (event.target.name == 'cuisine_id') {
      console.log(event.target.value)
      if (event.target.value == 'cuisine_id') {
        setErrors({
          ...errors,
          cuisine_error: true
        });
      } else {
        setErrors({
          ...errors,
          cuisine_error: false
        });
      }
    } else if (event.target.name === 'average_cost') {
      if (event.target.value == 'average_cost') {
        setErrors({
          ...errors,
          average: true
        });
      } else {
        setErrors({
          ...errors,
          average: false
        });
      }

    }

  }



  const handleChangeStatus = ({ meta, file }, status) => {

    console.log(file)
    if (status == 'done') {
      setTimeout(() => {
        setRestaurant({
          ...restaurant,
          image: file
        });
      }, 5000);
    }
  }

  function onFormSubmit(e) {
    e.preventDefault();

    let error = false;
    const errorObj = { ...errors };

    if (restaurant.name === '') {
      errorObj.name = true;
      error = true;
    }
    
    if (restaurant.email === '') {
      errorObj.email = true;
      error = true;
    }

    if (restaurant.firstName === '') {
      errorObj.firstname = true;
      error = true;
    }

    if (restaurant.lastName === '') {
      errorObj.lastname = true;
      error = true;
    }

    if (restaurant.phone === '') {
      errorObj.phone = true;
      error = true;
    }

    if (restaurant.image=== '') {
      errorObj.fileitem  = true;
      error = true;
    }

    if (restaurant.price === '') {
      errorObj.price = true;
      error = true;
    }

    if (restaurant.outlet_type === 'outlet_type') {
      errorObj.outlettype = true;
      error = true;
    }

    if (restaurant.business_category_id === 'business_category_id') {
      errorObj.category = true;
      error = true;
    }

    if (restaurant.cuisine_id === 'cuisine_id') {
      errorObj.cuisine_error = true;
      error = true;
    }

    if (restaurant.average_cost === 'average_cost') {
      errorObj.average = true;
      error = true;
    }


    setErrors(errorObj);
    


    if (error) {
      return;
    }
    try {
      // await createRestaurant(restaurant);
      dispatch(createRestaurantAction(restaurant, props.history));
    } catch (error) {
      console.log("Something is wrong");
    }
  }


  function fetchCuisine() {
    dispatch(getCuisineAction());
  }


  function fetchBusinessCategories(outlet_type) {
    dispatch(getBusinessCategoriesAction(outlet_type));
  }

  useEffect(() => {
    fetchCuisine();
  }, []);

  useEffect(() => {
    if (restaurant) {
      // setRestaurant({
      //     ...restaurant
      // });
    }
  }, [restaurant]);


  return (
    <div className="register">

      <div className="register-header">
        <div className="d-flex align-items-center justify-content-between">
          <img className='img-fluid' src={foodhublogo} />
          <div className="d-flex  language-wraper">
            <span className="px-1 border-right">EN</span>
            <span className="px-1">BN</span>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row hero-section">
          <div className="col-md-6 col-lg-6 left ">
            <h1 className="partner">PARTNER WITH US</h1>
            <p>We're hungry for the best things in life: delicious food, exploring the city and bringing the first bite of food to our customers.</p>
            <p >foodpanda is multi-national, fast-growing business that maintains its appeal as localised service with community ambition.</p>
          </div>
          <div className="col-md-6 col-lg-6 right">
            <div className="restaurant_form_wrapper rounded-0 p-4">
              <span className="fs-4 fw-bold text-center"> Interested? Fill in the form below to become our partner and increase your revenue!</span>
              <small className="pt-4">To sign up via Tel: 09678 561 561</small>
              <small className="pt-3">To sign up by yourself please fill in below form:</small>

              <form>
                <div className={errors.name ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  <input type="text" name='name' onChange={e => onFormFieldChange(e)} onBlur={handleInputBlur} />
                  <label>Outlet Name*</label>
                </div>
                {errors.name && <div className="text-danger fs-12 mt-1 ms-3">Field cannot be blank.</div>}

                {/* <div className={errors.outlettype ? "restaurant-input error mt-5" : "restaurant-input mt-5"}>
                  <Select name="outlet_type" onChange={e => onFormSelectChange(e)} onBlur={e => handleOutletBlur(e)} options={typeOption} />
                  <label>Type of Outlet*</label>
                </div> */}
                <div className="mt-5">
                  <TextField
                    id="outlined-select-currency"
                    select
                    className={errors.outlettype ? "error" : ""}
                    label="Type of Outlet*"
                    name="outlet_type"
                    value={restaurant?.outlet_type}
                    onChange={onFormSelectChange}
                    onBlur={handleSelectBlur}
                  >
                    <MenuItem value={restaurant?.outlet_type} disabled>Select Value</MenuItem>
                    {typeOption?.map((option) => (
                      <MenuItem key={option?.value} value={option?.value}>
                        {option?.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>


                {errors.outlettype && <div className="text-danger fs-12 mt-1 ms-3">Complete this field.</div>}


                {/* <div className={errors.category ? "restaurant-input error mt-5" : "restaurant-input mt-5"}> */}
                {/* <Select onChange={e => onFormSelectChange(e)} onBlur={e => handleCategory(e)} options={categoryOptions} />
                  <label>Category*</label> */}
                {category &&
                  <div className="mt-5">
                    <TextField
                      select
                      className={errors.category ? "error" : ""}
                      label="Category*"
                      name="business_category_id"
                      value={restaurant?.business_category_id}
                      onChange={onFormSelectChange}
                      onBlur={handleSelectBlur}
                    >
                      <MenuItem value={restaurant?.business_category_id} disabled>Select Value</MenuItem>
                      {categoryOptions?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                }
                {category &&  errors.category && <div className="text-danger fs-12 mt-1 ms-3">Complete this field.</div>}

                {
                  cuisine && outlet &&
                  // <div className={errors.cuisine_error ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  //   <Select onChange={e => onFormSelectChange(onFormSelectChange)} onBlur={e => handleCusine(e)} options={cuisineOptions} />
                  //   <label>Cusine*</label>
                  // </div>
                  <div className="mt-5">
                    <TextField
                        select
                      className={errors.cuisine_error ? "error" : ""}
                      label="Cusine*"
                      name="cuisine_id"
                      value={restaurant?.cuisine_id}
                      onChange={onFormSelectChange}
                      onBlur={handleSelectBlur}
                    >
                      <MenuItem value={restaurant?.cuisine_id} disabled>Select Value</MenuItem>
                      {cuisineOptions?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                }
                {cuisine && outlet &&  errors.cuisine_error && <div className="text-danger fs-12 mt-1 ms-3">Complete this field.</div>}

                {/* <div className={errors.average ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  <Select name="average_cost" onChange={e => {
                    onFormSelectChange(e)
                  }} onBlur={e => handleAverage(e)} options={averageCostOption} />
                
                  <label>What is the average cost of a meal for one person?*</label> */}

                <div className="mt-5">
                  <TextField
                    select
                    className={errors.average ? "error" : ""}
                    label="What is the average cost of a meal for one person?*"
                    name="average_cost"
                    value={restaurant?.average_cost}
                    onChange={onFormSelectChange}
                    onBlur={handleSelectBlur}
                  >
                    <MenuItem value={restaurant?.average_cost} disabled>Select Value</MenuItem>
                    {averageCostOption?.map((option) => (
                      <MenuItem key={option?.value} value={option?.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                {errors.average && <div className="text-danger fs-12 mt-1 ms-3">Complete this field.</div>}

                <div className={errors.firstname ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  <input type="text" name='firstName' onChange={e => onFormFieldChange(e)} onBlur={handleInputBlur} />
                  <label>First/Given Name*</label>
                </div>
                {errors.firstname && <div className="text-danger fs-12 mt-1 ms-3">Field cannot be blank.</div>}

                <div className={errors.lastname ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  <input type="text" name='lastName' onChange={e => onFormFieldChange(e)} onBlur={handleInputBlur} />
                  <label>Last/Family Name*</label>
                </div>
                {errors.lastname && <div className="text-danger fs-12 mt-1 ms-3">Field cannot be blank.</div>}
                <div className={errors.phone ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  <input type="number" name="phone" onChange={e => onFormFieldChange(e)} onBlur={handleInputBlur} placeholder="+880123456789" />
                  <label>Contact Number*</label>
                </div>
                {errors.phone && <div className="text-danger fs-12 mt-1 ms-3">Field cannot be blank.</div>}
                <div className={errors.email ? "restaurant-input  error mt-5" : "restaurant-input mt-5"}>
                  <input type="email" name="email" onChange={e => onFormFieldChange(e)} onBlur={handleInputBlur} placeholder="name@email.com" />
                  <label>Email*</label>
                </div>
                {errors.email && <div className="text-danger fs-12 mt-1 ms-3">Field cannot be blank.</div>}
                <div className=" mt-5" style={{ position: "relative" }}>
                  <input type="file" name="file" placeholder="name@email.com" id="fileupolad" onChange={handleChangeStatus} onClick={handleInputBlur}  />
                  <label className={errors.fileitem ? "errorfileupolad" : "fileupolad"}>Menu/Item List Upload*</label>
                  <label htmlFor="fileupolad" className={errors.fileitem ? " errorfileuploadlabel  d-flex align-items-center justify-content-center" : "fileuploadlabel d-flex align-items-center justify-content-center"}>
                    <div className="d-flex align-items-center justify-content-center">
                      <i className="mdi mdi-upload fs-2" style={{ color: "grey" }}></i>
                      <span>Choose File</span>
                    </div>
                  </label>
                </div>
                {errors.fileitem && <div className="text-danger fs-12 mt-1 ms-3">Please select file to upload!!</div>}
                <div className="mt-3 d-flex align-items-center" >
                  <input type="checkbox" onClick={handleInputBlur} name="is_price_not_fixed" id="agree" />
                  <label className=" m-0 pl-2" htmlFor="agree">Prices provided in the menu uploaded are not marked-up*</label>
                </div>
                {errors.price && <div className="text-danger fs-12 mt-1 ms-3">Complete this field.</div>}
                <div className="restaurant-input mt-5">
                  <input type="text" name="address" placeholder="Search here..." />
                  <i className="mdi mdi-magnify fs-4" style={{ position: "absolute", top: "10px", right: "15px" }}></i>
                  <label>Restaurant Address</label>
                </div>
                <input className="submitBtn mb-4 mt-3" type="submit" value="SUBMIT" onClick={e => onFormSubmit(e)} />
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="RestaurantRegStep d-flex align-items-center">
        <div className="container">
          <h2 className="fw-bold">Steps to Activation</h2>
          <div className="row">
            <div className="col-lg-3  col-12">
              <div className="RestaurantRegStep_card">
                <img src={step1} alt="" className="img-fluid" />
                <p className="mt-4">Step 1:</p>
                <p>Sign up online</p>
              </div>
            </div>
            <div className="col-lg-3  col-12">
              <div className="RestaurantRegStep_card">
                <img src={step2} alt="" className="img-fluid" />
                <p className="mt-4">Step 2:</p>
                <p>foodpanda sends the contract</p>
              </div>
            </div>
            <div className="col-lg-3  col-12">
              <div className="RestaurantRegStep_card">
                <img src={step3} alt="" className="img-fluid" />
                <p className="mt-4">Step 3:</p>
                <p>Sign the contract</p>
              </div>
            </div>
            <div className="col-lg-3  col-12">
              <div className="RestaurantRegStep_card">
                <img src={step4} alt="" className="img-fluid" />
                <p className="mt-4">Step 4:</p>
                <p>GO LIVE on foodpanda</p>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="RestaurantRegAdvantage">
        <div className="row">
          <div className="col-lg-4 col-12 p-0">
            <div className="RestaurantRegAdvantage_img">
              <img src={DeliveryBoy} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="col-lg-8 col-12 p-0">
            <div className="container" style={{ height: "100%" }}>
              <div className="RestaurantRegAdvantage_info">
                <h2 className="">Advantage of Joining Us</h2>

                <div className="row">
                  <div className="col-lg-1 col-3 d-flex justify-content-end">
                    <img src={iconcheck} className="img-fluid mt-3" alt="" />
                  </div>
                  <div className="col-lg-11  col-9">
                    <p className="p-head m-0">
                      More Revenue</p>
                    <p className="p-text">
                      With Food Hub, you will gain an additional source of income. Our
                      customers are continually searching the latest cool restaurants
                      in their city.
                    </p>
                  </div>



                  <div className="col-lg-1 col-3 d-flex justify-content-end">
                    <img src={iconcheck} className="img-fluid mt-3" alt="" />
                  </div>
                  <div className="col-lg-11  col-9">
                    <p className="p-head m-0">Dedicated Support</p>
                    <p className="p-text">
                      From perfecting your delivery menu and sending out weekly
                      reports, to improving your performance, we're here to help you
                      every step of the way.
                    </p>
                  </div>



                  <div className="col-lg-1 col-3 d-flex justify-content-end">
                    <img src={iconcheck} className="img-fluid mt-3" alt="" />
                  </div>
                  <div className="col-lg-11 col-9">
                    <p className="p-head m-0">Constant Flexibility</p>
                    <p className="p-text d-flex justify-content-end">
                      Pause orders if you're feeling overwhelmed. You decide for
                      yourself when you want to cook for your food lovers and are free
                      to leave on a monthly basis.
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="work-section">
        <h2 className="work-title text-center">How it works</h2>
        <div className="container work-container">
          <div className="row">
            <div className="col-md-3 col-lg-3 d-flex align-items-center flex-column">
              <img src={work1} alt="" className="lng-step-icon" />
              <p className="mt-5 work-content text-center">Customer enters a delivery address
                via the app or website and select a
                restaurant nearby.</p>
            </div>
            <div className="col-md-3 col-lg-3 d-flex align-items-center flex-column">
              <img src={work2} alt="" className="lng-step-icon" />
              <p className="mt-5 work-content text-center">Restaurant accepts the order
                through the tablet we provide,
                and starts preparing the food for a
                specific pick up time</p>
            </div>
            <div className="col-md-3 col-lg-3 d-flex align-items-center flex-column">
              <img src={work3} alt="" className="lng-step-icon" />
              <p className="mt-5 work-content text-center">Our rider arrives at the right time
                to collect and delivers the order
                within 30 minutes after the order was placed.</p>
            </div>
            <div className="col-md-3 col-lg-3 d-flex align-items-center flex-column">
              <img src={work4} alt="" className="lng-step-icon" />
              <p className="mt-5 work-content text-center">Foodpanda sends you the proceeds
                from your orders every month and
                provides deep insights on your
                performance.</p>
            </div>
          </div>
        </div>

        <div className="d-flex work_button">
          <button type="button" className="get_button"> Get Started</button>
        </div>


      </div>

      <div className="register-foooter">
        <div className="row fotter-content">
          <div className="col-md-6 col-lg-6">
            <img src={footerlogo} className="lng-footer-logo" alt="" />
            <ul className="list">
              <li className="pl-0">Help Center</li>
              <li className="pl-0">Terms and Conditions</li>
              <li className="pl-0">Privacy Policy</li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-6 footer-right">
            {/* <small>Social</small>
            <div className="d-flex social">
              <i className="mdi mdi-facebook mdi-48px"></i>
              <i className="mdi mdi-instagram mdi-48px"> </i>
            </div> */}

            <div class="lng-social-footer">
              <p class="">Social</p>
              <ul className="d-flex">
                <li class="lng-p-r-15 pl-0">
                  <a href="" target="_blank">
                    <img style={{ width: "44px" }} src="https://www.restaurant.foodpanda.com.bd/resource/1607615779000/FoodpandaResource/FoodpandaResource/images/icon-facebook.svg" />
                  </a>
                </li>
                <li class="lng-p-r-15">
                  <a href="" target="_blank">
                    <img style={{ width: "44px" }} src="https://www.restaurant.foodpanda.com.bd/resource/1607615779000/FoodpandaResource/FoodpandaResource/images/instagram.svg" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};

export default connect(mapStateToProps)(Register);

